import { AlertTypeStatus } from '../../types/serverNotifications/serverNotificationTypes';
import colorVariables from '../../stylesheets/variables.module.scss';

const notificationTypeAlertIcon = new Map([['SCRAPING', 'AutoFixHigh']]);

const notificationStatuses = [
    AlertTypeStatus.SUCCESS_WITH_ERRORS,
    AlertTypeStatus.FAILED,
    AlertTypeStatus.SUCCESS,
    AlertTypeStatus.CANCELLED,
];

const notificationStatusIcon: Record<AlertTypeStatus | 'UNKNOWN', string> = {
    FAILED: 'Close',
    SUCCESS: 'CheckCircle',
    CANCELLED: 'CancelOutlined',
    SUCCESS_WITH_ERRORS: 'WarningAmber',
    UNKNOWN: 'QuestionMarkOutlined',
};

const notificationStatusColor: Record<AlertTypeStatus | 'UNKNOWN', string> = {
    FAILED: '#d32f2f',
    SUCCESS: colorVariables.primaryBrigth,
    CANCELLED: '#ed6c02',
    SUCCESS_WITH_ERRORS: '#b28704',
    UNKNOWN: '#757575',
};

const notificationStatusBackgroundColor: Record<
    AlertTypeStatus | 'UNKNOWN',
    string
> = {
    FAILED: 'rgba(211, 47, 47, 0.2)',
    SUCCESS: '#1d9e7526',
    CANCELLED: 'rgba(237, 108, 2, 0.2)',
    SUCCESS_WITH_ERRORS: 'rgba(178, 135, 4, 0.2)',
    UNKNOWN: 'rgba(117, 117, 117, 0.2)',
};

/**
 * Extracts the alert type and status to select notification visuals.
 * @param alertTypeKey Backend key, such as SCRAPING_SUCCESS_WITH_ERRORS.
 * @returns Icons and color for the extracted type and status, with unknown fallbacks.
 */
export const getNotificationConfig = (alertTypeKey: string) => {
    const status = notificationStatuses.find(candidate =>
        `_${alertTypeKey}_`.includes(`_${candidate}_`)
    );
    const notificationType = status
        ? alertTypeKey.substring(0, alertTypeKey.indexOf(status) - 1)
        : alertTypeKey;
    const resolvedStatus = status ?? 'UNKNOWN';

    return {
        typeIcon:
            notificationTypeAlertIcon.get(notificationType) ?? 'Vibration',
        statusIcon: notificationStatusIcon[resolvedStatus],
        statusColor: notificationStatusColor[resolvedStatus],
        statusBackgroundColor:
            notificationStatusBackgroundColor[resolvedStatus],
    };
};

export const ZITONEO_HOTEL_ENTITY_TYPE = 'SupplierHotel';
